<template>
	<div v-show="pagination.pages > 0">
		<div class="row pagination-slider">
			<div class="col-xs-12 text-center">
				<div
					style="display: flex; align-items: center; justify-content: center"
				>
					<button
						class="btn btn-xs slider-item"
						@click="page(pagination.previous)"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="w-6 h-6"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M15.75 19.5L8.25 12l7.5-7.5"
							/>
						</svg>
					</button>
					<template v-if="rangeStart < 3">
						<button
							class="btn btn-xs slider-item"
							v-for="pagina in primeirasPaginas"
							:key="pagina"
							:class="{'slide-item-active': pagina == pagination.page}"
							@click="page(pagina)"
						>
							{{ pagina }}
						</button>
					</template>
					<template v-else>
						<button
							class="btn btn-xs slider-item"
							:class="{'slide-item-active': 1 == pagination.page}"
							@click.prevent="page(1)"
						>
							1
						</button>
						<button class="btn btn-xs slider-item">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
								class="w-6 h-6"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
								/>
							</svg>
						</button>
					</template>
					<template>
						<button
							class="btn btn-xs slider-item"
							v-for="pagina in meioPaginas"
							:key="pagina"
							:class="{'slide-item-active': pagina == pagination.page}"
							@click.prevent="page(pagina)"
						>
							{{ pagina }}
						</button>
					</template>
					<template v-if="rangeEnd >= pagination.pages - 2">
						<button
							class="btn btn-xs slider-item"
							v-for="pagina in ultimasPaginas"
							:key="pagina"
							:class="{'slide-item-active': pagina == pagination.page}"
							@click.prevent="page(pagina)"
						>
							{{ pagina }}
						</button>
					</template>
					<template v-else>
						<button class="btn btn-xs slider-item">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
								class="w-6 h-6"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
								/>
							</svg>
						</button>
						<button
							class="btn btn-xs slider-item"
							:class="{
								'slide-item-active': pagination.pages == pagination.page
							}"
							@click="page(pagination.pages)"
						>
							{{ pagination.pages }}
						</button>
					</template>
					<button class="btn btn-xs slider-item" @click="page(pagination.next)">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="w-6 h-6"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M8.25 4.5l7.5 7.5-7.5 7.5"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		pagination: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			rangeStart: 3,
			rangeEnd: 3
		}
	},
	computed: {
		primeirasPaginas() {
			let array = []
			for (let i = 1; i < this.rangeStart; i++) {
				array.push(i)
			}
			return array
		},
		meioPaginas() {
			let array = []
			for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
				array.push(i)
			}
			return array
		},
		ultimasPaginas() {
			let array = []
			for (let i = this.rangeEnd + 1; i <= this.pagination.pages; i++) {
				array.push(i)
			}
			return array
		}
	},
	watch: {
		pagination: {
			immediate: true,
			deep: true,
			handler() {
				const currentPage = Number(this.pagination.page)
				this.rangeStart = currentPage - 3
				this.rangeEnd = currentPage + 3

				if (this.rangeEnd > this.pagination.pages - 1) {
					this.rangeEnd = this.pagination.pages - 1
					this.rangeStart = this.pagination.pages - 3 * 2
					this.rangeStart = this.rangeStart < 1 ? 1 : this.rangeStart
				}

				if (this.rangeStart <= 1) {
					this.rangeStart = 1
					this.rangeEnd = Math.min(3 * 2 + 1, this.pagination.pages)
				}
			}
		}
	},
	methods: {
		page(page) {
			window.bus.$emit('page-goto', page)
		}
	}
}
</script>

<style scoped>
.slider-item {
	width: 22px;
	height: 22px;
	border-radius: 2px;
	margin: 2px;
	background-color: #e7e4e4;
	display: inline-block;
	box-shadow: 0px 1px 2px rgb(0 0 0 / 20%);
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
.slide-item-active {
	background-color: #0d8aee;
	transition: all 0.5s;
	color: #fff;
}
.pagination-slider {
	margin-top: 2px;
}
</style>